import { useQuery } from '@apollo/client'
import { graphql } from '~publish/gql'

import type {
  GetPostForCommentsPostCardQuery,
  GetPostForCommentsPostCardQueryVariables,
} from '~publish/gql/graphql'

export const GetPostForCommentsPostCard = graphql(/* GraphQL */ `
  query GetPostForCommentsPostCard($id: PostId!) {
    post(input: { id: $id }) {
      ...PostCard_Post
    }
  }
`)

type UseQueryResponse = ReturnType<
  typeof useQuery<
    GetPostForCommentsPostCardQuery,
    GetPostForCommentsPostCardQueryVariables
  >
>
export const useLoadCommentPostCard = (
  id: string,
  { skip = false } = {},
): UseQueryResponse =>
  useQuery(GetPostForCommentsPostCard, {
    variables: { id },
    skip,
  })
